import React, {useState} from 'react'
import {uploadPhoto, addPhotoToStorage} from '../../utils/uploadPhoto'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import EmojiEmotionsOutlinedIcon from '@material-ui/icons/EmojiEmotionsOutlined';
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import {useHistory} from 'react-router-dom';
import { useStore } from '../../StateManagement';
import { motion } from "framer-motion"
import { db, storage } from '../../Firebase/firebase'

function CreateGroupInfo({setShowCreateGroupInfo, newSelectedMembers, setShowParticipantMenu}) {
	const history = useHistory();
	const [groupName, setGroupName] = useState('');
	const [groupPhotoUrl, setGroupPhotoUrl] = useState('');
	const [stateData] = useStore();

	//  create New group
  const createGroup = () =>{
    db.collection('groups').add({
      groupName,
      adminName: stateData.userDetails.name,
      groupPhotoUrl,
      members: [...newSelectedMembers, stateData.userDetails]
    }).then((docRef)=> {
    	setShowParticipantMenu(false)
      setShowCreateGroupInfo(false)
      history.replace(`/chats/group/${docRef.id}`)
    })
  }

  const handleUploadPhoto = (e) => {
		uploadPhoto(e, stateData.userDetails.uid, storage, setGroupPhotoUrl)
	}

	return (
		<motion.div 
	    className="sidebar__create__participants group__info"
	    animate={{
	      x: 0,
	      opacity: 1
	    }}
	    initial={{
	      x: -30,
	      opacity: 0
	    }}
	    transition={{duration: 0.5}}
	    exit={{
        x: -100,
        opacity: 0
      }}
	  >
	    <div className="create__participants__container">
	      <div className="create__participants__header">
	        <ArrowBackIcon onClick={()=> {
	          setShowCreateGroupInfo(false)}} />
	        <h2>New group</h2>
	      </div>
	      <div className="group__image">
	        <input type="file" id="select__group__icon" onChange={handleUploadPhoto} />
	        <label htmlFor="select__group__icon" style={{backgroundImage: groupPhotoUrl && `url(${groupPhotoUrl})`}}>
	          {!groupPhotoUrl && 
	            <>
	              <CameraAltIcon />
	              <p>ADD GROUP <br /> ICON</p>
	            </> 
	          }
	        </label>
	        <div className="group__name">
	          <input 
	            type="text" 
	            placeholder="Group Subject" 
	            value={groupName} 
	            onChange={(e)=> {
	            if(e.target.value.length < 26) setGroupName(e.target.value);
	          }} 
	            /> 
	          <div>
	            <span>{25 - groupName.length}</span>
	            <EmojiEmotionsOutlinedIcon />
	          </div>
	        </div>
	      </div>
	      <div className="create__group__button">
	        <button disabled={groupName.length === 0 && true} onClick={createGroup} style={{opacity: groupName.length === 0 && '0.5'}}>
	          <DoneOutlinedIcon />
	        </button>
	      </div>
	    </div>
	  </motion.div>
	)
}

export default CreateGroupInfo